const toFixed2 = (i) => (!!i ? parseFloat((+i).toFixed(2)) : 0);
const toFixed5 = (i) => (!!i ? parseFloat((+i).toFixed(5)) : 0);
const capitalize = (i) =>
    i
        ?.toLowerCase()
        .replace(/_/g, ' ')
        .split(' ')
        .map((s) => `${s.charAt(0).toUpperCase()}${s.slice(1)}`)
        .join(' ');

const getCurrencySign = (currency: string): string => {
    if (!currency) {
        return '';
    }
    if ('GBP' === currency) {
        return '£';
    }
    if ('EUR' === currency) {
        return '€';
    }
};

const FormatFunctions = {
    toFixed2,
    toFixed5,
    formatName: capitalize, // backwards compatibility
    capitalize,
    getCurrencySign,
};

export { FormatFunctions };
